export default defineNuxtPlugin((nuxtApp) => {
  // Only the pages with a chart load ApexCharts.
  // No typescript declaration file available: https://github.com/apexcharts/vue3-apexcharts/issues/2
  // @ts-ignore
  nuxtApp.vueApp.component("apexchart", defineAsyncComponent(() => import("vue3-apexcharts")));
});
